import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Checkbox,
    Stack,
    Link,
    Button,
    Heading,
    Text,
    useColorModeValue,
    useToast,
  } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

  export default function AdminCard() {
    const [password, setPassword] = useState()
    const [email, setemail] = useState()  
    const [Loading ,setLoading]=useState()
    
    const toast = useToast();
    const navigate = useNavigate();

    const submitHandler=async()=>{
      setLoading(true);
      if ( !email || !password ) {
        toast({
          title: "Please Fill all the Fields",
          status: "info",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setTimeout(setLoading(false),4000) 
        return;
      }
      
      
      try {
        const config = {
          headers: {
            "Content-type": "application/json",
          },
        };
        const { data } = await axios.post(
          "https://clc-27nm.onrender.com/api/admin",
          {
           
            email,
            password,
          
          },
          config
        );
       
        localStorage.setItem("userInfo", JSON.stringify(data));
        setLoading(false);
        navigate("/admin")
      } catch (error) {
        toast({
          title: "Error Occured!",
          description: error.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setLoading(false);
      }
  
    }



    return (
      <div className="login">
        <Flex
          minH={"100vh"}
          align={"center"}
          justify={"center"}
          bg={useColorModeValue("gray.50", "gray.800")}
        >
          <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
            <Stack align={"center"}>
              <Heading fontSize={"4xl"}>Admin login</Heading>
            </Stack>
            <Box
              rounded={"lg"}
              bg={useColorModeValue("white", "gray.700")}
              boxShadow={"lg"}
              p={8}
            >
              <Stack spacing={4}>
                <FormControl id="email">
                  <FormLabel>Email address</FormLabel>
                  <Input type="email" value={email} placeholder="Enter your email"
          onChange={(e)=> setemail(e.target.value)}/>
                </FormControl>
                <FormControl id="password">
                  <FormLabel>Password</FormLabel>
                  <Input type="password" value={password}  placeholder="Enter your password"
          onChange={(e)=> setPassword(e.target.value)}/>
                </FormControl>
                <Stack spacing={5}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  ></Stack>
                  
                  <Button
                    bg={"blue.400"}
                    color={"white"}
                    _hover={{
                      bg: "blue.500",
                    }}
                    disabled={Loading}
                    onClick={submitHandler}
                    isLoading={Loading}
                  >
                    Sign in
                  </Button>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Flex>
      </div>
    );
  }
  